import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Sparkles, Search } from "lucide-react";
import { Seo } from "@/components/Seo";

// Release 1: route + component architecture for the future Direct Buyer journey.
// The full flow (Describe need -> Match potential -> Save -> Matches -> Professional
// connection) is Release 2. Gated by REACT_APP_DIRECT_BUYER_ENABLED so we never expose
// an unfinished workflow. When disabled, we show an honest, finished "launching soon" page.
const DIRECT_BUYER_ENABLED = process.env.REACT_APP_DIRECT_BUYER_ENABLED === "true";

export default function LookingForProperty() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-primary text-primary-foreground flex flex-col" data-testid="looking-for-property-page">
      <Seo
        title="Looking for Property — PropertyConnect"
        description="Tell PropertyConnect what you're looking for and get matched with the right properties and professionals across the Philippines."
        canonical="/looking-for-property"
        robots={DIRECT_BUYER_ENABLED ? "index,follow" : "noindex,follow"}
      />
      <div className="p-6 sm:p-8">
        <button onClick={() => nav("/login")} data-testid="buyer-back" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-16">
        <div className="w-full max-w-lg text-center">
          <div className="mx-auto h-14 w-14 rounded-2xl border border-accent/40 flex items-center justify-center mb-6">
            <Search className="h-7 w-7 text-accent" strokeWidth={1.75} />
          </div>
          <p className="inline-flex items-center gap-2 text-accent text-xs font-semibold uppercase tracking-wider">
            <Sparkles className="h-3.5 w-3.5" /> Launching soon
          </p>
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-3">
            Direct property search is on the way
          </h1>
          <p className="text-slate-300 mt-4 leading-relaxed">
            We're building a simple way for property seekers to describe what they need and get
            matched with the right properties and licensed professionals across the Philippines.
            It isn't open to the public just yet.
          </p>
          <p className="text-slate-400 text-sm mt-3">
            In the meantime, create an account or sign in to explore PropertyConnect.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/register" data-testid="buyer-create-account" className="w-full sm:w-auto h-11 px-6 rounded-xl bg-accent text-accent-foreground font-semibold flex items-center justify-center hover:bg-accent/90 transition-colors">
              Create account
            </Link>
            <Link to="/login" data-testid="buyer-signin" className="w-full sm:w-auto h-11 px-6 rounded-xl border border-white/20 text-white font-semibold flex items-center justify-center hover:bg-white/5 transition-colors">
              Sign in
            </Link>
          </div>
          {DIRECT_BUYER_ENABLED && (
            <p className="text-slate-500 text-xs mt-8">Direct Buyer flow is enabled — Release 2 experience mounts here.</p>
          )}
        </div>
      </div>
    </div>
  );
}
